import { FeatureFlagType, KameleoonClient } from '@kameleoon/javascript-sdk';
import { getSession } from 'next-auth/react';
import { useEffect, useState } from 'react';
import {
  DepsProvider,
  FlagState,
  KameleeonGoal,
  getConfiguration,
  getFlagStateForUser as getFlagStateForUserBase,
  getFlagsForUser as getFlagsForUserBase,
  trackConversion as trackConversionBase,
} from '../base';

let client: KameleoonClient | null = null;

const createClient = async (): Promise<KameleoonClient> => {
  const kameleoonClient = new KameleoonClient({
    siteCode: process.env.NEXT_PUBLIC_KAMELEOON_SITE_CODE,
    configuration: getConfiguration(),
  });
  await kameleoonClient.initialize();
  return kameleoonClient;
};

const getClient = async (): Promise<KameleoonClient> => {
  if (!client) {
    client = await createClient();
  }

  return client;
};

export const getVisitorCode = async (): Promise<string> => {
  try {
    const kameleoonClient = await getClient();

    const session = await getSession();
    const user = session?.user;
    if (user) {
      const { email, isAdmin } = user;

      if (isAdmin) return email;
    }

    return kameleoonClient.getVisitorCode({});
  } catch (error) {
    console.error(error);
    return '';
  }
};

export const depsProvider: DepsProvider = {
  getClient,
  getVisitorCode,
};

export const getFlagsForUser = async (): Promise<FeatureFlagType[]> =>
  getFlagsForUserBase(depsProvider);

export const getFlagStateForUser = async (
  flagName: string,
  variables?: string[]
): Promise<FlagState> =>
  getFlagStateForUserBase(depsProvider, flagName, variables);

export const trackConversion = async (goal: KameleeonGoal) =>
  trackConversionBase(depsProvider, goal);

type ExperimentationHookType = {
  flagName: string;
  variables?: string[];
};
export function useExperimentation(params: ExperimentationHookType) {
  const [flagState, setFlagState] = useState<FlagState>(false);
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getFlagStateForUser(params.flagName, params.variables)
      .then(result => {
        setFlagState(result);
        setIsValid(true);
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return [flagState, isValid, isLoading];
}
